// [임시 하드코딩] 상품별 예약차단 - 정규화 기능 구현 시 이 파일과 사용처 전부 제거 (2026-10-26)
// until: 'YYYY-MM-DD HH:mm' (한국시간) - 이 시각 "직전"까지 차단, 정각부터 예약 가능
// pdtCodes: 같은 시각에 열리는 상품코드를 배열로 묶음 (시각이 다르면 규칙을 따로 추가)
// ※ app.js의 RESERVATION_BLOCK_LIST와 반드시 같이 수정할 것
export const RESERVATION_BLOCK_LIST = [
    {
      pdtCodes: ['T-26102023XZC', 'T-26102483UBC', 'F-26102317EUC', 'F-26102329XPC'],   // 같은 시각에 열리는 상품들
      until: '2026-10-30 10:00',
      message: '10월 30일 오전 10시(한국시간)부터 예약이 가능합니다.',
    },
    // {
    //   pdtCodes: ['F-00003'],                          // 오픈 시각이 다르면 규칙을 따로
    //   until: '2026-11-05 14:00',
    //   message: '11월 5일 오후 2시(한국시간)부터 예약이 가능합니다.',
    // },
  ];
  
  // 'YYYY-MM-DD HH:mm'(한국시간) → epoch ms, 형식오류면 NaN
  export function toKSTMillis(until) {
    const m = /^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2})$/.exec(String(until ?? '').trim());
    if (!m) return NaN;
    return Date.parse(`${m[1]}T${m[2]}:${m[3]}:00+09:00`);
  }
  
  // 차단 중이면 규칙 객체(untilMs 포함), 아니면 null
  // 같은 상품코드가 여러 규칙에 있으면 가장 늦게 풀리는 규칙을 적용
  export function getActiveBlock(pdtCode, now = Date.now()) {
    const code = String(pdtCode ?? '').trim();
    if (!code) return null;
  
    let active = null;
    for (const rule of RESERVATION_BLOCK_LIST) {
      const codes = (Array.isArray(rule.pdtCodes) ? rule.pdtCodes : []).map(c => String(c).trim());
      if (!codes.includes(code)) continue;
  
      const untilMs = toKSTMillis(rule.until);
      if (Number.isNaN(untilMs)) {
        // 형식 오타 시 예약이 열려버리지 않도록 차단 유지
        console.error('[예약차단] until 형식오류:', rule);
        return { ...rule, untilMs };
      }
      if (now < untilMs && (!active || untilMs > active.untilMs)) {
        active = { ...rule, untilMs };
      }
    }
    return active;
  }